import { render, staticRenderFns } from "./VariantPriceModal.vue?vue&type=template&id=2bb5be9e"
import script from "./VariantPriceModal.vue?vue&type=script&lang=js"
export * from "./VariantPriceModal.vue?vue&type=script&lang=js"
import style0 from "./VariantPriceModal.vue?vue&type=style&index=0&id=2bb5be9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports